export const navigationRoutes = [
  // 航路指南
  {
    path: "/navigation/handbook",
    name: "navigation_handbook",
    meta: {
      isKeepAlive: false,
      title: "航路指南",
    },
    component: () => import("@/components/navigation/point/handbook/index.vue"),
  },
  // 港口资料
  {
    path: "/navigation/ports",
    name: "navigation_ports",
    meta: {
      isKeepAlive: false,
      title: "港口资料",
    },
    component: () => import("@/components/navigation/point/ports/index.vue"),
  },
  // 船舶航行法规
  {
    path: "/navigation/laws",
    name: "navigation_laws",
    meta: {
      isKeepAlive: false,
      title: "港口资料",
    },
    component: () => import("@/components/navigation/point/laws/index.vue"),
  },
  // 海图查询
  {
    path: "/navigation/chart",
    name: "navigation_chart",
    meta: {
      isKeepAlive: false,
      title: "海图查询",
    },
    component: () => import("@/components/navigation/chart/index.vue"),
  },
  // 海图详情
  {
    path: "/navigation/chart_details",
    name: "navigation_chart_details",
    meta: {
      isKeepAlive: false,
      title: "海图详情",
    },
    component: () => import("@/components/navigation/chart/detail/detail.vue"),
  },
  // 改正通告
  {
    path: "/correction_notice",
    name: "correction_notice",
    meta: {
      isKeepAlive: false,
      title: "改正通告",
    },
    component: () => import("@/components/navigation/notice/index.vue"),
  },
  // 桥梁通航
  {
    path: "/navigation/bridge",
    name: "navigation_bridge",
    meta: {
      isKeepAlive: false,
      title: "桥梁通航",
    },
    component: () => import("@/components/navigation/bridge/index.vue"),
  },
];
